import { memo } from 'react';
import type { TicketHealth } from '../../types/staff';
import { ticketHealthTone } from '../../utils/staffProfile';
import { cn } from '../../utils/cn';

interface TicketHealthBadgeProps {
  health: TicketHealth | string;
  /** Label to show when the observation is not tied to a ticket outcome. */
  emptyLabel?: string | null;
  className?: string;
}

/** Pill for the health of a ticket at observation time (healthy / slow / stalled / abandoned). */
export const TicketHealthBadge = memo(({ health, emptyLabel = null, className }: TicketHealthBadgeProps) => {
  const label = health || emptyLabel;
  if (!label) return null;
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold border capitalize',
        ticketHealthTone(health),
        className,
      )}
    >
      {label}
    </span>
  );
});

TicketHealthBadge.displayName = 'TicketHealthBadge';
